<template>
  <div class="section home-zpk">
    <home-title title="展品库" clickTitle @toList="toBaseList">
      <div class="cate" slot="cate">
        <span :class="{ 'active': cateIndex == index }" v-for="(item, index) in cateList" :key="index"
          @click="onChangeType(index)">{{ item.name }}</span>
      </div>
    </home-title>
    <div class="container">
      <div class="lists">
        <template v-if="!isLoading">
          <swiper class="swiper gallery-home" :key="swiperKey" :options="swiperOptionHome" ref="swiperHome">
            <swiper-slide :key="index" v-for="(item, index) in list">
              <CardArts @toDetails="gotoDetails" :base="cateList[cateIndex]" :list="item" />
            </swiper-slide>
          </swiper>
          <div class="swiper-button-next" @click="toNext"></div>
          <div class="swiper-button-prev" :class="{'swiper-button-disabled': !initSwiper}" @click="toPrev"></div>
        </template>
        <loading v-else />
      </div>
      <div class="flex jc">
        <div class="homeBottomMoreBtn" @click="toMore">
          <em>查看更多</em>
        </div>
      </div>
      <!-- <div class="types">
        <div class="item" :class="{active: i == cateIndex}" v-for="(v, i) in cateList" :key="i" @click="onChangeType(i)"><em>{{v.name || ''}}</em></div>
        <div class="item" @click="showMore"><em>更多</em></div>
      </div> -->

    </div>
  </div>
</template>

<script>
import homeTitle from './home-title.vue'
import colums from '@/colums/colums.js'  //展品库的分类名称
import CardArts from "@/pages/exhibit/components/CardArts.vue"
import defaultImg from '@/assets/images/defaultImg.png'
import loading from '@/components/common/loading'
export default {
  components: {
    homeTitle,
    loading,
    CardArts
  },
  name: 'zpk',
  props: {},
  data() {
    const _t = this
    return {
      cateIndex: 0,
      cateList: [],
      list: [],
      defaultImg,
      swiperHome: null,
      swiperOptionHome: {
        spaceBetween: 10,
        observer: true,
        // loop: true,
        on: {
          click(e) {
            const id = e.target.dataset.id
            id && _t.gotoDetails(id)
          },
        }
      },
      swiperKey: '',
      initSwiper: false,  // 第一次點擊左右按鈕無效，加個狀態判斷調用方法
      isLoading: false
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    initPage() {
      this.cateList = colums.exhibitCate.map(v => {
        return {
          ...v
        }
      })
      this.loadData()
    },
    async loadData() {
      let params = {
        page: 1,
        pageSize: 45,
        is_award: -1,
        is_check: -1,
        is_top: -1,
        recommend: 1,
        category: this.cateList[this.cateIndex].id
      };
      this.list = []
      this.isLoading = true
      try {
        const res = await this.$api.exhibitApi.getList(params)
        let list = res.data || []
        let h = 540
        let ext = ',x_20,y_50'
        if (params.category == 2) {
          h = 810
          ext = ',x_20,y_70'
        } else if (params.category == 3) {
          ext = ',x_20,y_90'
        }
        list = await Promise.all(
          list.map(async (v) => {
            return {
              ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_lfit,h_${h}`, false, ext),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
            };
          })
        );
        
        // list = this.$utils.randomList(list)
        list = list.reduce((acc, curr, index) => {
          var num = this.cateIndex == 1 ? 6 : 9
          if (index % num == 0) {
            acc.push([]);
          }
          acc[acc.length - 1].push(curr);
          return acc;
        }, []);
        this.list = list.filter(v => v.length && v.length > 3)

        this.swiperKey = `swiper_${Math.ceil(Math.random() * 100000)}`
        this.initSwiper = false
        this.initSwiperAction()
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    initSwiperAction() {
      const _t = this

      if (this.$refs.swiperHome) {
        this.swiperHome = this.$refs.swiperHome.swiper
        this.swiperHome && this.swiperHome.slideTo(0)
      } else {
        setTimeout(() => {
          _t.initSwiperAction()
        }, 100)
      }
    },
    onChangeType(index) {
      this.cateIndex = index
      this.loadData()
    },
    toNext() {
      if (!this.initSwiper) {
        this.initSwiper = true
        this.swiperHome.slideTo(1)
      } else {
        this.swiperHome.slideNext()
      }
    },
    toPrev() {
      this.swiperHome.slidePrev()
    },
    gotoDetails(row) {
      let hash = this.$utils.hashNum(row.no_access || 0)
      this.$router.push({
        path: '/exhibit/' + row.id + "/" + hash
      })
    },
    toBaseList() {
      this.$router.push('/exhibit')
    },
    toMore() {
      this.$router.push({
        path: `/exhibit`
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.home-zpk {
  background: #FCFBF8 url(~@/assets/images/home-zp-bg.png) center bottom no-repeat;
  background-size: 100%;
  overflow: hidden;
  padding-bottom: 49px;

  .home-title {
    padding-bottom: 40px;
  }

  .container {
    position: relative;

    &::after {
      content: "";
      width: 380px;
      height: 380px;
      background: url(~@/assets/images/home-zp-bg2.png) center center no-repeat;
      position: absolute;
      bottom: -108px;
      right: -365px;
    }

    .lists {
      box-sizing: border-box;
      min-height: 470px;
      .swiper-button-next,
      .swiper-button-prev {
        width: 20px;
        height: 34px;
        transition: all 0.35s;
        top: 45%;
        opacity: .35;
        background: url(~@/assets/images/arrow2.png) center center no-repeat;
        &.swiper-button-prev {
          background: url(~@/assets/images/arrow1.png) center center no-repeat;
        }

        &::after {
          display: none;
        }
      }

      .swiper-button-next {
        right: -73px;
        &:not(.swiper-button-disabled) {
          &:hover {
            opacity: 1;
          }
        }
      }

      .swiper-button-prev {
        left: -73px;
        &:not(.swiper-button-disabled) {
          &:hover {
            opacity: 1;
          }
        }
      }
    }

    /deep/ .homeBottomMoreBtn {
      em {
        &::before {
          background-color: #f6f3ee;
        }
      }
    }
  }
}
</style>